"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabViewWrappers = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@eig-builder/core-ui/Tab"));

var _styles = require("@eig-builder/core-ui/styles");

var _defaultViewWrapper = _interopRequireDefault(require("./components/default-view-wrapper"));

var _animatedViewWrapper = _interopRequireDefault(require("./components/animated-view-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Accessiability helper
var a11yProps = function a11yProps(index) {
  return {
    id: "full-width-tab-".concat(index),
    'aria-controls': "full-width-tabpanel-".concat(index)
  };
}; // Styling


var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.palette.black.lighter),
      flexGrow: 1,
      overflow: 'auto',
      '& button': {
        fontWeight: 300,
        fontSize: '14px',
        '&:hover': {
          background: "".concat(theme.palette.black.lightest),
          color: "".concat(theme.palette.black.dark)
        }
      },
      '& > div': {
        overflow: 'hidden',
        overflowX: 'scroll'
      }
    },
    activeState: {
      fontWeight: '600 !important',
      color: "".concat(theme.palette.black.dark, " !important")
    }
  };
}); // Mobile helper

var getInitialValue = function getInitialValue(mobileRes) {
  return mobileRes > window.innerWidth;
};

var useIsMobile = function useIsMobile(mobileRes) {
  var _useState = (0, _react.useState)(getInitialValue(mobileRes)),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    function updateSize() {
      if (mobileRes <= window.innerWidth) {
        setIsMobile(false);
      } else if (mobileRes > window.innerWidth) {
        setIsMobile(true);
      }
    }

    if (mobileRes && mobileRes > 0) {
      window.addEventListener('resize', updateSize); // Unmount

      return function () {
        return window.removeEventListener('resize', updateSize);
      };
    }
  }, []);
  return isMobile;
};

var TabViewWrappers = {
  Default: _defaultViewWrapper.default,
  Animated: _animatedViewWrapper.default
}; // Tabs Composition

exports.TabViewWrappers = TabViewWrappers;

var ResponsiveTabs = function ResponsiveTabs(_ref) {
  var tabs = _ref.tabs,
      views = _ref.views,
      value = _ref.value,
      variant = _ref.variant,
      handleChange = _ref.handleChange,
      fullWidth = _ref.fullWidth,
      ariaLabel = _ref.ariaLabel,
      mobileRes = _ref.mobileRes,
      classname = _ref.classname,
      modalclasses = _ref.modalclasses,
      ViewWrapper = _ref.viewWrapper;
  var currentlyMobile = useIsMobile(mobileRes);
  var classes = useStyles();

  var onChange = function onChange(event, newValue) {
    handleChange(newValue);
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Tabs.default, {
    value: value,
    className: "".concat(classes.root, " ").concat(modalclasses && modalclasses.root ? modalclasses.root : '', " ").concat(classname),
    onChange: onChange,
    indicatorColor: variant,
    textColor: variant,
    variant: fullWidth && !currentlyMobile ? 'fullWidth' : 'scrollable',
    scrollButtons: currentlyMobile ? 'on' : 'off',
    "aria-label": ariaLabel
  }, tabs.map(function (tab, index) {
    return _react.default.createElement(_Tab.default, _extends({
      className: index === value ? classes.activeState : '',
      key: index
    }, tab, a11yProps(index)));
  })), views && views.length > 0 && _react.default.createElement(ViewWrapper, {
    currentIndex: value
  }, views));
};

ResponsiveTabs.propTypes = {
  tabs: _propTypes.default.array.isRequired,
  views: _propTypes.default.array,
  value: _propTypes.default.number,
  variant: _propTypes.default.string,
  classname: _propTypes.default.string,
  modalclasses: _propTypes.default.any,
  handleChange: _propTypes.default.func.isRequired,
  fullWidth: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string,
  mobileRes: _propTypes.default.number,
  viewWrapper: _propTypes.default.func
};
ResponsiveTabs.defaultProps = {
  variant: 'primary',
  viewWrapper: TabViewWrappers.Default
};
var _default = ResponsiveTabs;
exports.default = _default;